export var ASSURANCE_CHECK_FIELD_ID;
(function (ASSURANCE_CHECK_FIELD_ID) {
    ASSURANCE_CHECK_FIELD_ID["FAKE_RECEIPT_DETECTION"] = "ASSR01";
    ASSURANCE_CHECK_FIELD_ID["VENDOR_LEGITIMACY"] = "ASSR02";
    ASSURANCE_CHECK_FIELD_ID["AMOUNT_ANOMALY_DETECTION"] = "ASSR03";
    ASSURANCE_CHECK_FIELD_ID["ALCOHOL_DETECTION"] = "ASSR04";
    ASSURANCE_CHECK_FIELD_ID["OUTSIDE_BUSINESS_HOURS"] = "ASSR05";
    ASSURANCE_CHECK_FIELD_ID["EXCESSIVE_TIP_DETECTION"] = "ASSR06";
    ASSURANCE_CHECK_FIELD_ID["LINE_ITEM_MISMATCH"] = "ASSR08";
    ASSURANCE_CHECK_FIELD_ID["ITEMIZED_MEAL_RECEIPT_CHECK"] = "ASSR09";
})(ASSURANCE_CHECK_FIELD_ID || (ASSURANCE_CHECK_FIELD_ID = {}));
export var ASSURANCE_STATUS;
(function (ASSURANCE_STATUS) {
    ASSURANCE_STATUS["PASS"] = "pass";
    ASSURANCE_STATUS["FAIL"] = "fail";
})(ASSURANCE_STATUS || (ASSURANCE_STATUS = {}));
export const ASSURANCE_STATUS_VALUES = Object.values(ASSURANCE_STATUS);
